module.exports = __webpack_public_path__ + "static/img/kq.d5603ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kq.png
// module id = 5frk
// module chunks = 1